import { CategorizedProductsFilterContainer } from "app/pages/Listing/ProductFilters/CategorizedProductsFilterContainer";

export default props => <CategorizedProductsFilterContainer {...props} />;
